import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { getQuery } from 'sutils';

const pfmLog = getQuery('PFM') === '1';

export default class TaskMonitor {
    private static instance: TaskMonitor;
    public static getInstance() {
        if (!TaskMonitor.instance) {
            TaskMonitor.instance = new TaskMonitor();
        }
        return TaskMonitor.instance;
    }

    private breadCrumbs: Array<{ name: string, args: any[] }>;
    private worker: any;

    public constructor() {
        // 面包屑，用于记录关键节点的操作路径
        this.breadCrumbs = [];
    }

    public async loadWorkerModule() {
        if (process.env.WORKER_DISABLE) return;
        return import(/* webpackChunkName: "worker" */ './taskAnalyse.worker.js') as any;
    }

    public async createWorker() {
        if (process.env.WORKER_DISABLE) return;

        // task数据分析线程
        const module = await this.loadWorkerModule();
        const TaskAnalyseWorker = module.default;
        this.worker = new TaskAnalyseWorker();
        this.worker.onmessage = (e) => {
            if (e.data?.performanceInfo) {
                // 上报单页渲染性能信息
                tdw({
                    opername: 'ppt_performance',
                    module: 'page_render',
                    action: 'caton_info',
                    ver6: JSON.stringify(e.data.performanceInfo),
                });
            }
        };
    }

    public startObserveLongtask = () => {
        if ('PerformanceObserver' in window) {
            this.createWorker();
            const observer = new PerformanceObserver((list) => {
                const entries = list.getEntries() || [];
                const entryInfoList: any[] = [];
                entries.forEach((entry) => {
                    if (entry.name.indexOf('(begin)') >= 0
                        || entry.name.indexOf('(end)') >= 0
                        || entry.entryType === 'longtask') {
                        entryInfoList.push({
                            name: entry.name,
                            entryType: entry.entryType,
                            startTime: entry.startTime,
                            duration: entry.duration,
                        });
                    }
                });
                this.worker?.postMessage?.({
                    entryInfoList,
                    breadCrumbs: this.breadCrumbs,
                    pfmLog,
                });
            });

            observer.observe({
                entryTypes: ['longtask', 'mark'],
            });
        }
    };

    public markOperationBlock(name: string, block?: () => void) {
        this.addMarkBegin(name);
        block?.();
        this.addMarkEnd(name);
    }

    public markPerformanceBlock(name: string, block?: () => void) {
        this.addMarkBegin(`${name}(Performance)`);
        block?.();
        this.addMarkEnd(`${name}(Performance)`);
    }

    public addMarkBegin(name: string) {
        if (window.performance?.mark) {
            window.performance.mark(`${name}(begin)`);
        }
    }

    public addMarkEnd(name: string) {
        if (window.performance?.mark) {
            window.performance.mark(`${name}(end)`);
        }
    }

    public addBreadCrumb(name: string, args: any[]) {
        const formatArgs = args.map((arg) => {
            if (typeof arg === 'object') {
                return arg.constructor.name;
            }
            return arg;
        });
        this.breadCrumbs.push({
            name,
            args: formatArgs,
        });
        if (this.breadCrumbs.length > 10) {
            this.breadCrumbs.splice(0, this.breadCrumbs.length - 10);
        }
    }
}
